module.exports = __webpack_public_path__ + "0b07dd254ad6eab078244f5b168df1fc.png";